import {
  BrowserRouter,
  Navigate,
  Route,
  // BrowserRouter as Router,
  Routes,
} from "react-router-dom";

import ScrollToTop from "./component/ScrollToTop";

import Footer from "./component/Footer";
import Header from "./component/Header";
import Home from "./screens/Home";
import Contact from "./screens/Contact";
import Blog from "./screens/Blog";
import OurServices from "./screens/OurServices";
import Engineering from "./screens/Specialization/Engineering";
import Medical from "./screens/Specialization/Medical";
import Technology from "./screens/Specialization/Technology";
import Accounting from "./screens/Specialization/Accounting";
import Insurance from "./screens/Specialization/Insurance";
import Legal from "./screens/Specialization/Legal";
import StaffingService from "./screens/StaffingServices";
import Banking from "./screens/Banking";
import InsurancePage from "./screens/Insurance";
import RetailEcommerce from "./screens/RetailEcommerce";
import HealthCare from "./screens/HealthCare";
import LifeScience from "./screens/LifeScience";
import Telecom from "./screens/Telecom";
import Careers from "./screens/Careers";

function RouteList() {
  return (
    <BrowserRouter>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<Navigate to="/" replace />} />

        <Route path="contact-us" element={<Contact />} />

        <Route path="blog" element={<Blog />} />
        <Route path="our-services" element={<OurServices />} />
        <Route path="engineering" element={<Engineering />} />
        <Route path="medicine" element={<Medical />} />

        <Route path="technology" element={<Technology />} />
        <Route
          path="accounting-and-finance-staffing"
          element={<Accounting />}
        />
        <Route path="insurance-and-executive" element={<Insurance />} />
        <Route path="legal" element={<Legal />} />

        <Route path="staffing-services" element={<StaffingService />} />

        <Route path="banking" element={<Banking />} />
        <Route path="insurance" element={<InsurancePage />} />

        <Route path="retail-ecommerce" element={<RetailEcommerce />} />

        <Route path="healthcare" element={<HealthCare />} />

        <Route path="pharmaceuticals-life-sciences" element={<LifeScience />} />

        <Route path="telecom" element={<Telecom />} />
        <Route path="careers" element={<Careers />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default RouteList;
